// extracted by mini-css-extract-plugin
export default {"container":"Rk-z","disabled":"Sk-z","subtotal":"Tk-z","legal":"Uk-z"};